import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./GenerarPedidoDist.css";

function GenerarPedidoDist() {
  const origenComponente = "GenerarPedidoDist";
  const { ecv_u, cv_u, usuarioSesion, esComputadora, rolUsuarioSesion } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [recargarSoloParaDistribuidor, erecargarSoloParaDistribuidor] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},

    //DATOS USUARIO
    v_formulario: false,
    da_distribuidores: [],
    d_codigoDistribuidor: ["DIST01", "ADIST01"].includes(rolUsuarioSesion) ? usuarioSesion : "",
    da_ayudantes: [],
    d_codigoAyudante: "",
    d_actualizarTabla: false,
    d_totalSolicitado: "",
    d_codigoUsuarioActual: "",
    d_fechaRecojo: "",
    d_comentario: "",
    d_nombreUsuarioSeleccionado: "",

    //ESTADO PROCESAOR API
    i_procesandoApi: false,
    i_primeraCarga: true,
    d_esperandoProcesoTabla: false,
  });

  useEffect(() => {
    if (!["DIST01", "ADIST01"].includes(rolUsuarioSesion)) {
      const listaDistribuidoresAPI = _api_.f_listaDistribuidores({
        timeout: 5000,
        origen: origenComponente,
      });
      listaDistribuidoresAPI.respuesta.then((dPC) => {
        _f_.asignar(ecv_u, dPC, true, origenComponente);
        if (!dPC.error) {
          console.log(dPC.contenido);
          _f_.asignar(ev_u, { da_distribuidores: dPC.contenido.Distribuidores });
        }
        _f_.asignar(ev_u, { i_primeraCarga: false });
      });
    }
  }, [recargaComponente]);

  useEffect(() => {
    console.log("entre aqui a lista de ayudantes");
    if (v_u.d_codigoDistribuidor !== "" && v_u.d_codigoAyudante == "") {
      console.log("entre a DIS01 EN AYUDANTES", v_u.d_codigoDistribuidor);
      const listaAyudantesAPI = _api_.f_listarAyudantesDistribuidor({
        parametros: { codUsuario: v_u.d_codigoDistribuidor },
        timeout: 5000,
        origen: origenComponente,
      });
      listaAyudantesAPI.respuesta.then((dPC) => {
        _f_.asignar(ecv_u, dPC, true, origenComponente);
        console.log(dPC);
        if (!dPC.error) {
          //console.log(dPC.contenido);
          _f_.asignar(ev_u, {
            da_ayudantes: dPC.contenido.ayudanteDistribuidores,
          });
        }
        _f_.asignar(ev_u, { i_primeraCarga: false });
      });

      const ultimoPedidoAPI = _api_.f_generarPedidoDistribuidor({
        parametros: {
          codUsuario: v_u.d_codigoDistribuidor,
          tipoDistribucion: 2,
        },
        timeout: 5000,
        origen: origenComponente,
      });
      _f_.asignar(ev_u, { i_procesandoApi: true });
      ultimoPedidoAPI.respuesta.then((dPC) => {
        _f_.asignar(ecv_u, dPC, true, origenComponente);
        if (!dPC.error) {
          _f_.asignar(ev_u, {
            do_datosTabla: dPC.contenido,
            do_filtros: dPC.contenido.filtros,
            da_grid: dPC.contenido.grid,
            da_headgrid: dPC.contenido.headgrid,
            d_multiselecion: dPC.contenido.multiseleccion,
            d_totalSolicitado: dPC.contenido.totalPedido,
          });
        }
        _f_.asignar(ev_u, { i_procesandoApi: false });
      });
    }
  }, [v_u.d_codigoDistribuidor, v_u.d_codigoAyudante, recargarSoloParaDistribuidor]);

  useEffect(() => {
    if (v_u.d_codigoAyudante !== "") {
      const ultimoPedidoAPI = _api_.f_generarPedidoDistribuidor({
        parametros: {
          codUsuario: v_u.d_codigoAyudante,
          tipoDistribucion: 2,
        },
        timeout: 5000,
        origen: origenComponente,
      });
      _f_.asignar(ev_u, { i_procesandoApi: true });
      ultimoPedidoAPI.respuesta.then((dPC) => {
        _f_.asignar(ecv_u, dPC, true, origenComponente);
        if (!dPC.error) {
          _f_.asignar(ev_u, {
            do_datosTabla: dPC.contenido,
            do_filtros: dPC.contenido.filtros,
            da_grid: dPC.contenido.grid,
            da_headgrid: dPC.contenido.headgrid,
            d_multiselecion: dPC.contenido.multiseleccion,
            d_totalSolicitado: dPC.contenido.totalPedido,
          });
        }
        _f_.asignar(ev_u, { i_procesandoApi: false });
      });
    }
  }, [v_u.d_codigoAyudante]);

  if (v_u.i_primeraCarga) return <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />;

  //if (cv_u.error) return <div>error</div>;
  return (
    <div className="generarPedidoDistCSS-contenedor">
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.limpiarAsignacion(ev_c, Object.keys(v_c));
          }}>
          {v_c.errores_mostrar && <_lul_.ListaUL texto={v_c.modal_mensaje} listaElementos={v_c.errores_lista} />}
          {v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto={v_c.modal_mensaje}
              fBotonAceptar={() => {
                flushSync(() => {
                  _f_.asignar(ev_c, {
                    modal_mostrar: false,
                  });
                });

                _f_.asignar(ev_c, {
                  modal_mostrar: true,
                  preConfirmar_mostrar: false,
                  procesandoAccion_mostrar: true,
                });
                const llamadoAPI = v_c.preConfirmar_funcion?.(v_c.preConfirmar_funcion_parametros);
                llamadoAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  flushSync(() => {
                    _f_.asignar(ev_c, {
                      modal_mostrar: false,
                      procesandoAccion_mostrar: false,
                    });
                  });
                  if (!dPC.error) {
                    _f_.asignar(ev_c, {
                      modal_mostrar: true,
                      postConfirmar_mostrar: true,
                    });
                  }
                });
                // _f_.limpiarAsignacion(ev_c, Object.keys(v_c));
              }}
              fBotonCancelar={() => {
                _f_.limpiarAsignacion(ev_c, Object.keys(v_c));
              }}
            />
          )}
          {v_c.procesandoAccion_mostrar && (
            <_procAcc_.ProcesandoAccion
              accion={() => {
                _f_.asignar(ev_c, {
                  modal_titulo: "⏳ Procesando",
                });
              }}
            />
          )}

          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              accion={() => {
                _f_.asignar(ev_c, {
                  modal_titulo: "✅ Éxito",
                  modal_mensaje: `El pedido de "${["DIST01"].includes(rolUsuarioSesion) && v_u.d_codigoAyudante == "" ? usuarioSesion : v_u.d_nombreUsuarioSeleccionado}" se proceso correctamente`,
                });
              }}
              texto={v_c.modal_mensaje}
              fBotonDeAcuerdo={() => {
                if (!["DIST01"].includes(rolUsuarioSesion)) {
                  _f_.limpiarAsignacion(ev_c, Object.keys(v_c));
                  _f_.limpiarAsignacion(ev_u, Object.keys(v_u));
                } else {
                  _f_.asignar(ev_u, { d_codigoAyudante: "" });
                  _f_.asignar(ev_c, {
                    modal_mostrar: false,
                    preConfirmar_mostrar: false,
                    procesandoAccion_mostrar: false,
                    postConfirmar_mostrar: false,
                  });
                  erecargarSoloParaDistribuidor((prev) => !prev);
                }
                erecargaComponente((prev) => {
                  return !prev;
                });
              }}
            />
          )}
        </ModalInformacion>
      )}

      <div className="titulo-componente">{"Generar Pedido Distribuidor"}</div>
      <div className={"generarPedidoDistCSS-cabecera"}>
        {!["DESP01"].includes(rolUsuarioSesion) && (
          <_div_.Div2
            texto={`Total: ${_f_.formatearValor({
              valor: v_u.d_totalSolicitado,
              moneda: "PEN",
              precision: 2,
              tipo: "moneda",
            })}`}
          />
        )}
        {!["DIST01", "ADIST01"].includes(rolUsuarioSesion) && (
          <_opt_.Opcion2
            texto="Distribuidores"
            clave={["codUsuario"]}
            valor={["Nombre", "ApellidoPaterno", "ApellidoMaterno"]}
            opciones={v_u.da_distribuidores || []}
            name={"wefwfwefwef"}
            estilos={{ flexGrow: 0, width: "100%" }}
            seleccionado={v_u.d_codigoDistribuidor}
            onBlur={(evento) => {
              //console.log("distribuidores", evento.target.value);
              _f_.asignar(ev_u, {
                d_codigoDistribuidor: evento.target.getAttribute("value"),
                d_codigoAyudante: "",
                da_ayudantes: [],
                da_grid: [],
                da_headgrid: [],
                do_datosTabla: {},
                d_nombreUsuarioSeleccionado: evento.target.value,
              });
            }}
          />
        )}
        <_opt_.Opcion2
          texto="Ayudantes Distribuidor"
          clave={["codUsuario"]}
          valor={["Nombre", "ApellidoPaterno", "ApellidoMaterno"]}
          opciones={v_u.da_ayudantes || []}
          name={"wefwfwefwef"}
          estilos={{ flexGrow: 0, width: "100%" }}
          seleccionado={v_u.d_codigoAyudante}
          onBlur={(evento) => {
            console.log("ayudantes", evento.target);
            _f_.asignar(ev_u, {
              d_codigoAyudante: evento.target.getAttribute("value"),
              d_nombreUsuarioSeleccionado: evento.target.value,
            });
          }}
        />
        <_ipt_.Input4
          tipo="date"
          defaultValue={_f_.fechaActual({ formato: "yyyy-mm-dd" })}
          estilos={{ width: "100%" }}
          texto="Fecha de Pedido"
          disabled
        />
        <_ipt_.Input4
          key={v_u.d_fechaRecojo || "fecha_vacía"}
          tipo="date"
          defaultValue={_f_.formatearFecha({
            valor: v_u.d_fechaRecojo,
            formato: "yyyy-mm-dd",
          })}
          estilos={{ width: "100%" }}
          texto="Fecha de Recojo"
          onChange={(evento) => {
            //console.log(evento.target.value);
            _f_.asignar(ev_u, { d_fechaRecojo: evento.target.value });
          }}
        />
      </div>

      <Filtros
        filtros={v_u.do_filtros}
        funcionObtenerValores={(valores) => {
          console.log(valores);
          _f_.asignar(ev_u, { do_filtrosActualizados: valores });
        }}
      />

      <div className="generarPedidoDistCSS-cuerpo">
        {v_u.i_procesandoApi ? (
          <_anim_.SpinnerHTML estilos={{ height: "5rem", color: "green" }} />
        ) : (
          <_tabla_.Tabla
            origen={origenComponente}
            cabecera={v_u.da_headgrid}
            registros={v_u.da_grid}
            filtros={v_u.do_filtrosActualizados}
            modoVista={"modo2"}
            permiteVerCategoriaCompleta={true}
            permiteMultiseleccion={v_u.d_multiselecion}
            permiteOpciones={true}
            opcionesPorDefecto={0b00_000_000}
            camposCodigosSeleccion={["codigo"]}
            campoCodigoCategoria={"categoria"}
            campoCodigoRegistrosPorCategoria={"registros"}
            campoOpcionesTablaInterna={"opcionesTablaInterna"}
            datosComplementarios={{
              codigoPrecioVenta: v_u.d_codigoDistribuidor,
              ...v_u.do_datosTabla,
            }}
            reglasDeEstadoRegistros={v_u.do_datosTabla.reglasDeEstadoRegistros}
            mapaDeComponentes={{
              formulario: _form_.Formulario,
              0b1: _form_.Formulario,
              0b010_000_000: _form_.Formulario,
            }}
            permiteDespliegueInferiorPorRegistro={false}
            permiteDetalleAlTocarElemento={true}
            fObtenerSeleccionados={(seleccionados) => {
              _f_.asignar(ev_u, { do_seleccionados: seleccionados });
            }}
            fNotificarActualizacionDeTabla={(actualizar) => {
              if (actualizar) {
                _f_.asignar(ev_u, {
                  d_actualizarTabla: !v_u.d_actualizarTabla,
                });
              }
            }}
            fObtenerDatosParcialesActualizados={(datos) => {
              console.log(datos);
              _f_.asignar(ev_u, { d_totalSolicitado: datos?.total_pedido });
            }}
            fObtenerEstadoProcesando={(estado) => {
              // console.log("esta procesando la tabla:",estado)
              _f_.asignar(ev_u, { d_esperandoProcesoTabla: estado });
            }}
          />
        )}
      </div>
      <div className={"generarPedidoCSS-comentario"}>
        {Object.keys(v_u.do_filtros).length > 0 && (
          <_txta_.TextArea
            texto="Ingrese un comentario"
            estilos={{ anchoTA: "100%" }}
            onChange={(evento) => {
              //console.log(evento.target.value)
              _f_.asignar(ev_u, { d_comentario: evento.target.value });
            }}
          />
        )}
      </div>

      <div className="generarPedidoDistCSS-opciones">
        {Object.keys(v_u.do_filtros).length > 0 && (
          <_btn_.Boton
            disabled={v_u.d_esperandoProcesoTabla}
            texto="Solicitar Pedido"
            tipo="btn-2"
            estilos={{ anchoB2: "10rem", color: "#4e942e" }}
            procesando={v_u.i_procesandoApi}
            onClick={() => {
              //console.log(v_u.do_datosTabla);
              const usuarioSeleccionado = v_u.do_datosTabla?.usuarioSolicitante ?? "";
              if (v_u.d_fechaRecojo != "" && usuarioSeleccionado != "") {
                console.log("entre a llamar api");
                _f_.asignar(ev_c, {
                  modal_mostrar: true,
                  modal_estilos: { anchoMI: "30rem" },
                  modal_titulo: "❗Confirmar Acción",
                  modal_mensaje: `¿Seguro que desea generar el pedido para "${["DIST01"].includes(rolUsuarioSesion) && v_u.d_codigoAyudante == "" ? usuarioSesion : v_u.d_nombreUsuarioSeleccionado}"?`,
                  preConfirmar_mostrar: true,
                  preConfirmar_funcion: _api_.f_solicitarPedido,
                  preConfirmar_funcion_parametros: {
                    parametros: {
                      codUsuario: usuarioSeleccionado,
                      codPedido: v_u.do_datosTabla.codPedido,
                      pedidooentrega: 1,
                      fechaEntregaEstimada: v_u.d_fechaRecojo + "T" + _f_.obtenerHoraActual(),
                      comentario: v_u.d_comentario,
                      tipo_comprobante: null, //para pedido distribuidor
                      tipo_documento: null, //para pedido distribuidor
                      numero_documento: null, //para pedido distribuidor
                      nombre_cliente: null, //para pedido distribuidor
                    },
                    timeout: 5000,
                    origen: origenComponente,
                  },
                });
              } else {
                let errores = [];
                if (usuarioSeleccionado == "") {
                  errores.push("Es necesario seleccionar un distribuidor o ayudante de distribuidor");
                }
                if (v_u.d_fechaRecojo == "") {
                  errores.push("Es necesario ingresar la fecha de Recojo");
                }
                _f_.asignar(ev_c, {
                  modal_mostrar: true,
                  modal_titulo: "🚨 Error",
                  modal_estilos: { anchoMI: "30rem" },
                  modal_mensaje: "Faltan los siguiente Datos:",
                  errores_lista: errores,
                  errores_mostrar: true,
                });
              }
            }}
          />
        )}
      </div>
    </div>
  );
}
export default GenerarPedidoDist;
